export const nAIFilterTagAssetTags = [
  "Tag",
  "FilterTag",
  "nAI",
  "label",
  "key:contents.rawdata.label",
];
